export class User {
  public name: string;
  public role: string;
  public siteId?: string;
  public userId?: number;

  constructor(
    public email: string,
    public password: string
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/models/user.model.ts